import { ArrowRight, CalendarDays, CheckCircle2, Clock3, Inbox, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';
import { MetricCard } from '../components/MetricCard';
import { Sparkline } from '../components/Sparkline';
import { buildKpis, dashboardCopy } from '../lib/metrics';
import { isDemoMode } from '../lib/supabase';
import { usePortal } from '../state/PortalContext';

export function DashboardPage() {
  const { persona, leads, activities, weeklySeries, dashboardSnapshot } = usePortal();
  const copy = dashboardCopy(persona);
  const metrics = buildKpis(persona, leads, dashboardSnapshot, isDemoMode);
  const pendingShared = leads.filter((lead) => lead.assignmentState === 'pending').length;
  const openItems = leads.filter((lead) => !['ganho', 'perdido'].includes(lead.status)).length;
  const todayLabel = new Intl.DateTimeFormat('pt-BR', { day: 'numeric', month: 'long' }).format(new Date());
  return (
    <>
      <div className="hero-row">
        <div><span className="eyebrow">{copy.eyebrow}</span><h1>{copy.title}</h1><p>{copy.intro}</p></div>
        <div className="date-chip"><CalendarDays size={18} /> {todayLabel}</div>
      </div>
      <section className="metrics-grid" aria-label="Indicadores principais">
        {metrics.map((metric) => <MetricCard key={metric.label} metric={metric} />)}
      </section>
      <div className="dashboard-grid">
        <section className="panel chart-panel">
          <div className="panel-head"><div><span className="overline">Tendencia</span><h2>{persona.role === 'manager' ? 'Ritmo comercial' : 'Meu ritmo'}</h2></div><span className="period-chip">12 semanas</span></div>
          <Sparkline values={weeklySeries} />
        </section>
        <section className="panel next-actions">
          <div className="panel-head"><div><span className="overline">Foco do dia</span><h2>Proximas acoes</h2></div><Clock3 size={19} /></div>
          <div className="action-list">
            <div><span className="action-icon action-icon--coral"><Inbox size={17} /></span><div><strong>{persona.role === 'manager' ? 'Atribuir leads compartilhados' : 'Revisar pendencias'}</strong><small>{persona.role === 'manager' ? `${pendingShared} aguardam um responsavel comercial` : `${openItems} itens em andamento`}</small></div></div>
            <div><span className="action-icon action-icon--teal"><RefreshCw size={17} /></span><div><strong>Confirmar retornos</strong><small>Agenda atualizada ate 14h</small></div></div>
            <div><span className="action-icon action-icon--navy"><CheckCircle2 size={17} /></span><div><strong>Continuar Academy</strong><small>Modulo LGPD concluido</small></div></div>
          </div>
          <Link to="/oportunidades" className="text-link">Abrir minha fila <ArrowRight size={16} /></Link>
        </section>
        <section className="panel activity-panel">
          <div className="panel-head"><div><span className="overline">Agora</span><h2>{persona.role === 'manager' ? 'Atividade da operacao' : 'Minha atividade'}</h2></div></div>
          {activities.length ? <div className="timeline">{activities.slice(0, 4).map((activity) => (
            <div className="timeline-item" key={activity.id}><span className={`timeline-dot timeline-dot--${activity.kind}`} /><div><strong>{activity.title}</strong><small>{activity.detail}</small></div><time>{activity.at}</time></div>
          ))}</div> : <div className="empty-state"><CheckCircle2 size={28} /><strong>Tudo em ordem</strong><p>Nenhuma atividade recente para o seu perfil.</p></div>}
        </section>
        <section className="panel privacy-panel">
          <ShieldNotice />
        </section>
      </div>
    </>
  );
}

function ShieldNotice() {
  return <><span className="overline">Privacidade aplicada</span><h2>O que voce ve e pessoal</h2><p>Seus indicadores nao incluem numeros de colegas. Somente a gestao autorizada acessa detalhes da equipe.</p><div className="privacy-seal"><span>RLS</span><div><strong>Controle por funcao</strong><small>Protecao no banco e na interface</small></div></div></>;
}

